import { useEvaluatorStore } from '@/components/EvaluatorCrudPane/store/evaluatorStore';
import { EvaluatedEntityType } from '@/components/EvaluatorCrudPane/utils/serializeFeedbackUIToLC';
import { useParsedManifest } from '@/components/EvaluatorCrudPane/utils/useParsedManifest';

export const useIsPromptLoading = (
  evaluatedEntityType: EvaluatedEntityType
) => {
  const { isHubManifestLoading } = useParsedManifest(evaluatedEntityType);

  // Check if the evaluator store has been populated with data
  const promptMessages = useEvaluatorStore((state) => state.promptMessages);
  const model = useEvaluatorStore((state) => state.model);
  const evaluatorType = useEvaluatorStore((state) => state.evaluatorType);

  // Show loading state if hub manifest is loading or if store hasn't been populated yet
  const isLoading =
    isHubManifestLoading ||
    (evaluatorType === 'prompt' && (!promptMessages || !model)) ||
    (evaluatorType === 'hub' && !model);
  return isLoading;
};
